const API_PATH = "https://api.worldspinner.com/worldservice/culture";

export async function requestNames(cultureNbr: string) {
    try {
        const response = await fetch(`${API_PATH}/` + cultureNbr + "/exampleNames/", {
            "headers": {
                "accept": "*/*",
                "accept-language": "en-US,en;q=0.9",
                "cache-control": "no-cache",
                "content-type": "application/json",
                "pragma": "no-cache",
                "sec-ch-ua": "\"Not?A_Brand\";v=\"8\", \"Chromium\";v=\"108\", \"Google Chrome\";v=\"108\"",
                "sec-ch-ua-mobile": "?0",
                "sec-ch-ua-platform": "\"macOS\"",
                "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors",
                "sec-fetch-site": "same-site",
            },
            "body": null,
            "method": "GET"
        });

        if (response.status === 200) {
            // console.log("requestNames: ", response);
            const result = await response.json();
            // console.log("requestNames: JSON = ", result);
            return result;
        }
        else {
            console.log("HTTP-Error: ", response)
        }
    } catch (e) {
        console.log("Device ERROR: ", e);
    }
}
